import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-543c546c")

_pushScopeId("data-v-543c546c")
const _hoisted_1 = { class: "LTLOrderHeaderActions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_big_plus = _resolveComponent("icon-big-plus")!
  const _component_s_icon_button = _resolveComponent("s-icon-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_cancel = _resolveComponent("icon-cancel")!
  const _component_icon_print = _resolveComponent("icon-print")!
  const _component_cancel_order = _resolveComponent("cancel-order")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isCanEditOrder)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: `/order/ltl/${_ctx.$route.params.order_id}/update`
        }, {
          default: _withId(() => [
            _createVNode(_component_s_icon_button, { content: "Добавить накладную" }, {
              default: _withId(() => [
                _createVNode(_component_icon_big_plus)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (_ctx.isCanCancelOrder)
      ? (_openBlock(), _createBlock(_component_s_icon_button, {
          key: 1,
          loading: _ctx.isCancelLoading,
          content: "Отменить заказ",
          onClick: _ctx.openModal
        }, {
          default: _withId(() => [
            _createVNode(_component_icon_cancel)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_s_icon_button, {
      content: "Распечатать",
      onClick: _ctx.printInvoices
    }, {
      default: _withId(() => [
        _createVNode(_component_icon_print)
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.isCancelModalOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 2,
          onClose: _ctx.closeModal
        }, {
          body: _withId(() => [
            _createVNode(_component_cancel_order, {
              loading: _ctx.isCancelLoading,
              onClose: _ctx.closeModal,
              onConfirm: _ctx.cancelOrderHandler
            }, null, 8, ["loading", "onClose", "onConfirm"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
})